import { IconButton, Typography } from "@mui/material";
import { lazy, useEffect, useState } from "react";
import { DeleteIcon } from "src/components/icons/ActionIcons";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import { useUserData } from "src/context/userContext";
import { asiakas_fetch } from "src/data/asiakas/AsiakasFunctions";
import gridPalkkiVisibilityClass from "src/data/gridPalkki/gridPalkkiVisibilityClass";
import PropTypes from "prop-types";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
const AsiakasSelectorSearch = lazy(() =>
  import("src/components/asiakas/AsiakasSelectorSearch/AsiakasSelectorSearch")
);

export default function GridPalkkiEditor_VisibilityTab({ palkki }) {
  const { userAsiakas, user, token } = useUserData();
  const [isLoading, setIsLoading] = useState(true);
  const [asiakasList, setAsiakasList] = useState([]);

  useEffect(() => {
    const asynk1 = async () => {
      const asiakasList = await gridPalkkiVisibilityClass.getAsiakasList(palkki.palkkiId, token);
      setAsiakasList(asiakasList);
      setIsLoading(false);
    };
    asynk1();
  }, [userAsiakas]);

  const handleAdd = async (id) => {
    setIsLoading(true);
    gridPalkkiVisibilityClass.addAsiakas(palkki.palkkiId, id, token); // await
    const asiakas = await asiakas_fetch(user, id, token, null, userAsiakas.asiakasId);
    setAsiakasList((prevAsiakasList) => [
      ...prevAsiakasList,
      {
        asiakasId: asiakas.globalAsiakas.asiakasId,
        asiakasNimi: asiakas.globalAsiakas.asiakasNimi,
        grid_palkki_id: palkki.palkkiId,
      },
    ]);
    setIsLoading(false);
  };

  const handleDelete = (id) => {
    gridPalkkiVisibilityClass.deleteAsiakas(palkki.palkkiId, id, token); // await
    setAsiakasList((prevAsiakasList) =>
      prevAsiakasList.filter((asiakas) => asiakas.asiakasId !== id)
    );
  };
  return (
    <>
      <ProgressBar show={isLoading} />
      <div className="spaceBetween" style={{ flexWrap: "wrap", gap: 12 }}>
        <div style={{ width: "65%" }}>
          <Typography variant="h6">Näkyvyys</Typography>
          <Typography variant="body">Lisää asiakas</Typography>

          <LazyLoader>
            <AsiakasSelectorSearch
              setAsiakasId={handleAdd}
              defaultAsiakasId={null}
              showEditButton={false}
              label=""
              variant="standard"
              shrinkLabel
            />
          </LazyLoader>
        </div>
        <div style={{ width: "30%" }}>
          {!isLoading && asiakasList.length === 0 && <>Ei asiakkaita</>}
          {asiakasList.map((asiakas) => (
            <div key={asiakas.asiakasId} className="spaceBetween">
              <div>{asiakas.asiakasNimi}</div>
              <div>
                <IconButton onClick={() => handleDelete(asiakas.asiakasId)}>
                  <DeleteIcon />
                </IconButton>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

GridPalkkiEditor_VisibilityTab.propTypes = {
  palkki: PropTypes.object,
};
